import { AuthContext } from "./authContext";
import {useContext} from "react";
import { useState, useEffect} from "react";
import { fetchEmployeebyEmail, fetchEmployees, fetchDest, getsignin } from "../api/customerapi";
import { useAppData } from "./appDataContext.js";
import { applyDevIdentity } from "./devIdentity.js";

// const GetRole = () => {

//     const {User} = useContext(AuthContext)
//     //console.log(User)
//     const { appData, loading } = useAppData();
//     const [cuser, setcuser]=useState(true);
//     const [role, setrole]=useState(true);


// //var cuser, role;


// const getemp=async(email)=>{
//   try{
//   //  const storedData = localStorage.getItem("appData");
//   //   //   console.log(storedData)
//   //   if (storedData) {
//   //     var temp=JSON.parse(storedData)
//       // console.log(temp.cuser)
//       // console.log(temp.role)
//       // setcuser(temp.cuser)
//       // setrole(temp.role)
//     //}else{
//   const emp= await fetchEmployeebyEmail(email);
//   console.log(emp.data)
//  setcuser(emp.data.proxy_name)
//  setrole(emp.data.role)
//  // }
// }catch(err){
//   console.log(err)
// }
//   //role=emp.data.role
// }



// if(User !==null && User.email){
//   getemp(User.email)
 
//   // console.log(data)
//   // cuser=data.cuser
//   // role=data.role
// }
//  //console.log(employeelist)
     
//     return ( {cuser, role} );
// }

const GetRole = () => {
  const { User } = useContext(AuthContext);
  const { appData, setAppData, loading: contextLoading } = useAppData();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    cuser: null,
    role: null,
    employeelist: [],
    destinationlist: [],
  });

  // useEffect(() => {

  //    const checksignin = async () => {
  //  const signin = await getsignin(User.email);
  //     console.log(signin.data)
  //     if(signin.data.length>0){
  //       if(!signin.data[0].logged_in){
  //         alert("Sign in again")
  //         window.location=("/")
  //       }
  //     }
  //   }

  //   checksignin()
  //   }, []);

  useEffect(() => {
    
    //alert("Loading")
    const loadAppData = async () => {
     
      if (contextLoading) return; // wait for provider to finish localStorage load

      // ✅ If all data already exists in appData, use it immediately
      if (
        appData?.cuser &&
        appData?.role &&
        appData?.employeelist?.length &&
        appData?.destinationlist?.length
      ) {
        setData(appData);
        setLoading(false);
        return;
      }

      // Otherwise, fetch missing pieces from server
      try {
        let newData = { ...appData };

        // Fetch employee basic info
        if (User?.email && (!appData?.cuser || !appData?.role)) {
          const emp = await fetchEmployeebyEmail(User.email);
          newData.cuser = emp.data.proxy_name;
          newData.role = emp.data.role;
        }

        // Fetch employee list
        if (!appData?.employeelist?.length) {
          const empList = await fetchEmployees();
          newData.employeelist = empList.data;
        }

        // Fetch destination list
        if (!appData?.destinationlist?.length) {
          const destData = await fetchDest();
          const temp = destData.data.filter((d) => "order" in d);
          newData.destinationlist = temp[0]?.dest || [];
        }

        // Save new data both locally and in context (persists to localStorage)
        setData(newData);
        setAppData(newData);
      } catch (err) {
        console.error("Error loading app data:", err);
      } finally {
        setLoading(false);
      }
    };

    loadAppData();
  }, [User, appData, contextLoading, setAppData]);

  // Single choke point — every consumer of GetRole goes through here, so a dev
  // override applies no matter which branch above produced the data (cache or fetch).
  return applyDevIdentity({ ...data, loading });
};
 
export default GetRole;

